module.exports = __webpack_public_path__ + "img/mono_12.81ef6595.png";